(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewFlyingExperiance.controller:CrewFlyingExperianceCtrl
   *
   * @description
   *
   */
  angular
    .module('crewFlyingExperiance')
    .controller('CrewFlyingExperianceCtrl', CrewFlyingExperianceCtrl);

  function CrewFlyingExperianceCtrl(CommonMasterData, $sce, crewScheduleService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewFlyingExperianceCtrl';

    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        leaveTypes: [],
        crewType: null,
        crewId: null,
        crew: null
      },
      masterList: {
        crewTypes: [],
        crewList: [],
        leaveTypeList: [],
        fromTimeInvalid: false,
        toTimeInvalid: false,
        fromDateAfterToDate : false,
        invalidCrew : false
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function (params) {
      searchLeaveDetailsReport(params);
    };

    function searchLeaveDetailsReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var rptDesign = "crew_fly_experiance_report.rptdesign";
        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      searchParamMap["crewId"] = param.crewId;
      searchParamMap["referrer"] = window.location.origin;

      return searchParamMap;
    }
    
    // check from date and to date
	function istoDateBeforeFromDate() {
		return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
				.isBefore(
						moment(vm.model.searchCriteria.fromDate,
								"DD/MM/YYYY"));
	}
	;

    function getLeaveTypesParamValue(param) {
      var leaveTypes = '';
      for (var j = 0; j < param.leaveTypes.length; j++) {
        if (j == 0) {
          leaveTypes = param.leaveTypes[j].eventCode;
        } else {
          leaveTypes += ',' + param.leaveTypes[j].eventCode;
        }
      }
      return leaveTypes;

    }

    function isValidSearchParams(params) {
    	setValidationFlags();
      	// if date invalid
	  	if (vm.model.masterList.toTimeInvalid
				|| vm.model.masterList.fromTimeInvalid) {
	  		vm.model.masterList.fromDateAfterToDate = false;
			return false;
		} else if (istoDateBeforeFromDate()) {
			vm.model.masterList.fromDateAfterToDate = true;
			return false;
		} else {
			vm.model.masterList.fromDateAfterToDate = false;
			if (!!vm.model.searchCriteria.crew && !!vm.model.searchCriteria.crew.crewId) {
				vm.model.masterList.invalidCrew = false;
				return true;
			}
			vm.model.masterList.invalidCrew = true;
			return false;
		} 
    }

    function setValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }       
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    vm.loadCrewListByType = function (crewType) {
      loadCrewList(crewType);
    };    

    vm.changeSearchField = function (searchCriteria, flag) {
    	setValidationFlags();
		if (!vm.model.masterList.toDateFormatInvalid
				&& !vm.model.masterList.fromDateFormatInvalid) {
			if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		} else {
			vm.model.masterList.fromDateAfterToDate = false;
		}
		
		if (flag == 'crewType') {
			vm.model.searchCriteria.crewId = null;
			vm.model.searchCriteria.crew = null;
			if (!!vm.model.searchCriteria.crewType 
        		&& !!searchCriteria.crewType.crewTypeCode) {
				loadCrewList(searchCriteria.crewType.crewTypeCode);                
			} else {
        	vm.model.masterList.crewList = [];    
			}
		} else if (flag == 'crewName') {
			if(!!vm.model.searchCriteria.crew && !!vm.model.searchCriteria.crew.crewId) {
				vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
				vm.model.masterList.invalidCrew = false;
			} else {
				vm.model.searchCriteria.crewId = null;
				vm.model.masterList.invalidCrew = true;
			}
		}
    }
 
    function loadCrewList(crewType) {

      var load = function () {
        var param = {};
        param.crewType = crewType;
        param.active = true;

        CommonMasterData.loadCrewList(param,
          function (response) {
            vm.model.masterList.crewList = crewScheduleService.adaptCrewList(response);
          },
          function () {
            console.log('Crew list retrieval error');
          }
        );
      };
      //always loading the crewlist
      load();
    }

    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    })();
  }
}());
